<script lang="ts">
  import { getContext } from "svelte";
  import { VisioMapApp } from "./vg/visiomap";

  const app = getContext<VisioMapApp>('app');
  const { T } = app;
</script>

<div>
  <strong>{$T`info_title`}</strong>
  <p>{$T`info_text`}</p>
</div>